<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <b-card>
          <PageHeader :title="title" :items="items" style="margin-top: -30px"/>
          <form action="">
            <div class="form-row">
              <div class="col-md-6 col-sm-6 col-lg-4">
                <label for="c_village_id">Village</label>
                <select v-model="search_data.c_village_id" id="c_village_id" name="c_village_id" class="form-control form-control-sm">
                  <option selected :value="''">Select a village</option>
                  <option v-for="(village, index) in villages" :key="index" :value="village.id">{{ village.id }} : {{ village.desc }}</option>
                </select>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-4">
                <label for="c_mouza_id">Mouza</label>
                <select v-model="search_data.c_mouza_id" id="c_mouza_id" name="c_mouza_id" class="form-control form-control-sm">
                  <option selected :value="''">Select a Mouza</option>
                  <option v-for="(mouza, index) in mouzas" :key="index" :value="mouza.id">{{ mouza.id }} : {{ mouza.desc }}</option>
                </select>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-4" style="margin-top: 3px;">
                <button class="btn btn-success btn-sm mt-3"  @click.prevent="search()">Search</button>
              </div>
            </div>

          </form>
        </b-card>

        <b-card>
          <div class="row mb-2" v-if="land_infos.length > 0">
            <div class="col-sm-6">
              <span class="badge badge-success mr-2">Total Search Data Found: {{ land_infos.length }}</span>
            </div>
            <div class="col-sm-6">
              <download-excel
                  class = "btn btn-light float-right"
                  :data = "land_infos"
                  :fields = "land_field"
                  :meta="json_meta"
                  worksheet = "Land Report"
                  name = "land_report.xls">
                Download Land Report
              </download-excel>
            </div>
          </div>
          <div class="scrollable-table table-responsive" style="overflow-x: auto">
            <table class="table table-centered table-striped">
              <thead>
              <tr>
                <th>Sl</th>
                <th>Village</th>
                <th>Mouza</th>
                <th>Total A</th>
                <th>Total B</th>
                <th>Total(A, B)</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(land_info, index) in land_infos" :key="index">
                <td>{{ index + 1 }}</td>
                <td>
                  <router-link :to="{
                          name: 'landReportVillage',
                          params: { village_id: land_info.id }}" tag="a" target="_blank">{{ land_info.desc }}
                  </router-link>
                </td>
                <td>
                  <router-link :to="{
                          name: 'landReportMouza',
                          params: { mouza_id: land_info.mouza.id }}" tag="a" target="_blank">{{ land_info.mouza.desc }}
                  </router-link>

                </td>
                <td>{{ land_info.total_count_a ? land_info.total_count_a : 0 }}</td>
                <td>{{ land_info.total_count_b ?  land_info.total_count_b: 0 }}</td>
                <td>{{ land_info.total_a_b ? land_info.total_a_b : 0 }}</td>
              </tr>
              </tbody>
            </table>
            <h5 v-if="!flag" class="text-center text-secondary">
              No Data Found
            </h5>
          </div>
        </b-card>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@src/app.config";
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";
import http from "@state/http";

export default {
  page: {
    title: "List SES Land",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Search SES Land",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Land",
          active: true
        }
      ],
      land_infos: {},
      search_data: {
        c_village_id: '',
        c_mouza_id: '',
      },
      villages: [],
      mouzas: [],
      land_field: {
        'Village': 'desc',
        'Mouza':  'mouza.desc',
        'Total A': {
          callback: (value) => {
            return `${value.total_count_a ? value.total_count_a : 0}`;
          }
        },
        'Total B': {
          callback: (value) => {
            return `${value.total_count_b ? value.total_count_b : 0}`;
          }
        },
        'Total(A, B)': {
          callback: (value) => {
            return `${value.total_a_b ? value.total_a_b : 0}`;
          }
        },
      },
      json_meta: [
        [
          {
            'key': 'charset',
            'value': 'utf-8'
          }
        ]
      ],
      flag: false
    };
  },

  mounted() {
    this.getCodes();
  },
  methods: {
    getCodes() {
      http.get("api/ses/codes").then(response => {
        if (!response.error) {
          let data = response.data;
          this.villages = data.villages;
          this.mouzas = data.mouzas;
        }
      });
    },
    search() {
      http.post("api/ses/land/report/search", this.search_data).then(response => {
        if (!response.error) {
          this.flag = true;
          this.land_infos = response.data.land_infos;
        }
      });
    },
    async fetchData(){
      const response = await http.post("api/ses/download", this.search_data);
      return response.data.land_infos;
    },
  },
  computed: {
    userPermission () {
      return this.$store.state.user
    }
  },
  created () {
    this.$store.dispatch('getUserPermission')
  },
};
</script>
